export default {
  app: {
    notFound: {
      title: 'Side ikke funnet.',
      subtitle: 'Det ser ut som du har gått deg vill.',
      text: 'Ikke bekymre deg, vi hjelper deg med å navigere herfra',
    },
  },
};
